import { AlignmentType, HeadingLevel, ImageRun, Paragraph, TextRun, TextWrappingSide, TextWrappingType, WidthType } from 'docx';
import thirdimg from '../../../../../../Assests/ReportImages/image3png.png'
import summary from '../../../../../../Assests/ReportImages/executiveSummary.png'
const heading3 = await fetch(thirdimg).then(response => response.blob())
const circuit = await fetch(summary).then(response => response.blob())
const imagethree = new ImageRun({
    type: 'png',
    data: await heading3.arrayBuffer(),
    transformation: {
        width: 150,
        height: 120
    },
});

export const imageThree = new Paragraph({
    indent: { left: 130 },
    spacing: { before: 400 },
    alignment: AlignmentType.LEFT,
    children: [imagethree]
})

export const summaryHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "3. Executive Summary",
            size: 40,
            color: "0189f9",
            font: "Gill Sans MT",
            bold: true,
        })
    ],
    heading: HeadingLevel.HEADING_2,
})

export function summaryText(customerName, testStartDate, testEndDate) {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th';
            else {
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            }
        }
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const formattedDate = `${date.getDate()}`;
        const ordinalSuffix = getOrdinalSuffix(date.getDate());
        const formatMonth = monthNames[date.getMonth()];
        const formatYear = date.getFullYear();

        return {
            formattedDate,
            ordinalSuffix,
            formatMonth,
            formatYear
        };
    };

    const formattedStartDate = formatDate(testStartDate);
    const formattedEndDate = formatDate(testEndDate);
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600 },
        spacing: { before: 150 },
        // spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
        alignment: AlignmentType.LEFT,
        children: [
            new TextRun({
                text: customerName,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false,
                bold: true
            }),
            new TextRun({
                text: ' engaged',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: ' ISECURION ',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false,
                bold: true
            }),
            new TextRun({
                text: 'for performing Secure Source Code Audit of their Application. The testing was executed from',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false,
                bold: false
            }),

            new TextRun({
                text: ' ' + formattedStartDate.formattedDate,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),

            new TextRun({
                text: formattedStartDate.ordinalSuffix,
                superScript: true,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formatMonth + ' ' + formattedStartDate.formatYear + ' ',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: 'to',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formattedDate,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: formattedEndDate.ordinalSuffix,
                superScript: true,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formatMonth + ' ' + formattedEndDate.formatYear + ' from',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ISECURION Office, Bangalore. This report documents the findings made by the team during the automated and manual review of the application source code.',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false,
                bold: false
            }),

        ],
    });
}

export const summaryImage = new Paragraph({
    children: [
        new ImageRun({
            type: 'png',
            data: await circuit.arrayBuffer(),
            transformation: { width: 200, height: 150 },
            floating: {
                horizontalPosition: { offset: 5410000 },
                verticalPosition: { offset: 2595000, },
                wrap: { type: TextWrappingType.SQUARE, side: TextWrappingSide.BOTH_SIDES },
                margins: { top: 201440, bottom: 201440 },
            },
        })
    ],
    alignment: AlignmentType.LEFT,
})

export const SecurityHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "Security review was carried out with two objectives:",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})


export const SecurityBulletOne = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "The first was to find out vulnerabilities that can be seen and compromised by malicious users from the Internet.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})

export const SecurityBulleTwo = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 100 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Secondly to identify vulnerabilities in the application code that can lead to security pitfalls.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})

export const secondReviewHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "As part of review certain vulnerabilities was observed and it should be addressed as early as possible.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})
export const secondbulletOne = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Hardcoded Credentials in the code.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})

export const secondbulletwo = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Hardcoded Secret.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})

export const secondbulleThree = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "SQL Injection.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})


export const recommendsText = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "ISECURION recommends the following:",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})


export const recommendsBulletOne = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Ensure that High/Medium vulnerabilities are fixed. ",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})


export const recommendsBulletTwo = new Paragraph({
    indent: { left: 1400 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "As part of an effective organizational risk management strategy, secure code review should be conducted on regular basis.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            bold: false,
            italics: false
        })
    ],

})